import { Divider, Header } from "semantic-ui-react";

const CSRText = () => {
  return (
    <div>
      <Header
        content="1. Availability"
        subheader="Set the days of the week and the hours you are available for jobs. By setting your availability, you become eligible to appear in searches by attorneys on Stenexus that are looking for CSR services."
      />
      <Header
        content="2. Profile"
        subheader="Fill out as much detail as possible to help improve your visibility in search. Here you can also provide your rates for various services. These rates will be used to produce the invoice at the end of a job."
      />
      <Header
        content="3. Stripe Account"
        subheader="Complete the setup of your Stripe account in order to receive payouts from Stenexus."
      />
      <div>
        <Divider horizontal section />
      </div>
      <div>
        <p>
          Once the setup is completed, you will receive an email notification
          whenever a job request is made by an attorney user of Stenexus. You
          can view and update the requests from the Jobs menu.
        </p>
      </div>
    </div>
  );
};
export default CSRText;
